/**
 * @file index.tsx
 *
 * @fileoverview Renders a call to action button row.
 */

import React from 'react';
import { Box } from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { CtaButtonParagraph } from '~/jobiqo/types/types';
import LinkButton from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import Link from '~/jobiqo/components/Link';
import NextLink from 'next/link';

interface CTAButtonProps {
  row: CtaButtonParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}
export const CTAButton = ({ row, maxContainerSize }: CTAButtonProps) => {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      paddingTop={row.spacing ?? 12}
      paddingBottom={row.spacing ?? 12}
      paddingLeft={[6, 12]}
      paddingRight={[6, 12]}
      marginTop={0}
      backgroundColorOverride={
        row.background ? `var(--color-${row.background})` : `var(--color-gray9)`
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        {row.button1 && row.button1?.url && row.button1?.text && (
          <div style={{ textAlign: 'center' }}>
            <Link prefetch={false} asChild>
              <LinkButton
                linkElement={NextLink}
                {...getFormattedPageLink(row.button1?.url)}
                buttonStyle={row.color as any}
              >
                {row.button1?.text}
              </LinkButton>
            </Link>
          </div>
        )}
      </Main>
    </Box>
  );
};
export default CTAButton;
